<div [formGroup]="formGroup">
    <mat-checkbox [formControlName]="control.name">{{control.displayText}}</mat-checkbox>
</div>